import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadClerk, SSO_RETURN_PATH } from '@/lib/clerk';

const SsoCallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const clerk = await loadClerk();
        await clerk.handleRedirectCallback({
          signInForceRedirectUrl: SSO_RETURN_PATH,
          signUpForceRedirectUrl: SSO_RETURN_PATH,
        });
      } catch {
        navigate('/login?sso_error=1', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-300">Signing you in…</p>
      </div>
    </div>
  );
};

export default SsoCallbackPage;
